<template>
    <div
        v-show="visible"
        id="loader"
        class="fixed inset-0 m-0 p-0 bg-purple-light/20 z-50 flex items-center justify-center"
    >
        <div 
            class="inline-block w-12 h-12 relative"
        >
            <div class="w-12 h-12 absolute border-4 border-purple-light rounded-full animate-ping"></div>
            <div class="w-6 h-6 left-3 top-3 absolute border-4 border-purple-light rounded-full animate-ping delay-500"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
        	visible: { default: false },
        }
    }
</script>

<style scoped>

</style>
